import { Injectable } from '@angular/core';

import { TermsAndConditionsMetadata } from '../models/terms-and-conditions-metadata.model';

enum SalesArea {
  nl = 'NL',
  be = 'BE',
  pl = 'PL',
  de = 'DE',
}

@Injectable({ providedIn: 'root' })
export class TermsAndConditionsAssetsService {
  private static readonly generalTermsAndConditions: Record<SalesArea, TermsAndConditionsMetadata> = {
    [SalesArea.nl]: {
      title: 'Algemene leveringsvoorwaarden',
      translationKey: 'terms-and-conditions.general-terms-and-conditions',
      url: 'https://www.agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf',
    },
    [SalesArea.be]: {
      title: 'Algemene leveringsvoorwaarden',
      translationKey: 'terms-and-conditions.general-terms-and-conditions',
      url: 'https://www.agrifirm.be/footer---filter-items/algemene-leveringsvoorwaarden/',
    },
    [SalesArea.pl]: {
      title: 'Ogólne Warunki Sprzedaży',
      translationKey: 'terms-and-conditions.general-terms-and-conditions',
      url: 'https://www.agrifirm.pl/globalassets/agrifirm-group/agrifirm-pl/pliki/ows/owz-agrifirm-2021-ab1.pdf',
    },
    [SalesArea.de]: {
      title: 'Allgemeine Lieferbedingungen',
      translationKey: 'terms-and-conditions.general-terms-and-conditions',
      url: 'https://www.agrifirm.de/footer-items/allgemeine-lieferbedingungen/',
    },
  };

  private static readonly deliveryConditions: Record<SalesArea, TermsAndConditionsMetadata[]> = {
    [SalesArea.nl]: [
      {
        title: 'Leveringscondities Herkauwers',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-ruminants.nl.pdf',
      },
      {
        title: 'Leveringscondities Pluimvee',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-poultry.nl.pdf',
      },
      {
        title: 'Leveringscondities Varkens',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-pigs.nl.pdf',
      },
      {
        title: 'Leveringscondities Meststoffen, Gewasverzorgingsmiddelen, Zaden en Bedrijfsbenodigdheden',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-fertilizers-crop-protection-seeds-supplies.nl.pdf',
      },
    ],
    [SalesArea.de]: [
      {
        title: 'Lieferbedingungen Wiederkäuer',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-ruminants.de.pdf',
      },
      {
        title: 'Lieferbedingungen Geflügel',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-poultry.de.pdf',
      },
      {
        title: 'Lieferbedingungen Schweine',
        url: '/assets/documents/terms-and-conditions/delivery-conditions-pigs.de.pdf',
      },
    ],
    [SalesArea.be]: [],
    [SalesArea.pl]: [],
  };

  private static readonly otherDocuments: Record<SalesArea, TermsAndConditionsMetadata[]> = {
    [SalesArea.nl]: [],
    [SalesArea.be]: [
      {
        title: 'Contact en locaties',
        translationKey: 'terms-and-conditions.additional-information.contact-and-locations',
        url: 'https://www.agrifirm.be/over-ons/contact--locaties/',
      },
    ],
    [SalesArea.de]: [],
    [SalesArea.pl]: [],
  };

  public getGeneralTermsAndConditions = (salesArea: string): TermsAndConditionsMetadata | null => {
    const _salesArea = this.getMatchingSalesArea(salesArea);
    return TermsAndConditionsAssetsService.generalTermsAndConditions[_salesArea] ?? null;
  };

  public getDeliveryConditions = (salesArea: string): TermsAndConditionsMetadata[] => {
    const _salesArea = this.getMatchingSalesArea(salesArea);
    return TermsAndConditionsAssetsService.deliveryConditions[_salesArea] ?? [];
  };

  public getOtherDocuments = (salesArea: string): TermsAndConditionsMetadata[] => {
    const _salesArea = this.getMatchingSalesArea(salesArea);
    return TermsAndConditionsAssetsService.otherDocuments[_salesArea] ?? [];
  };

  private getMatchingSalesArea = (salesArea: string): SalesArea | null => {
    const salesAreas = Object.values(SalesArea);
    return salesAreas.find((area) => salesArea.startsWith(area)) ?? null;
  };
}
